module.exports = __webpack_public_path__ + "img/FR18315.ac07463e.png";